import React from 'react';
import { useTranslation } from 'react-i18next';
import { Zap } from 'lucide-react';

const SMBBetaHero = () => {
  const { t } = useTranslation();
  return (
    <section className="pt-32 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center space-x-2 bg-secondary text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
          <Zap className="w-4 h-4" />
          <span>{t('smb.hero.badge')}</span>
        </div>

        <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 leading-tight mb-6">
          {t('smb.hero.title')}
          <span className="block mt-2 text-primary">
            {t('smb.hero.titleAccent')}
          </span>
        </h1>

        <p className="text-xl text-slate-600 leading-relaxed mb-8 max-w-3xl mx-auto">
          {t('smb.hero.description')}
        </p>

        <div className="inline-block bg-primary/10 border border-primary/20 px-6 py-4 rounded-lg mb-8">
          <p className="text-lg font-medium text-slate-900">
            {t('smb.hero.valueProp')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SMBBetaHero;
